import { render, staticRenderFns } from "./model-list.vue?vue&type=template&id=2800286b&"
import script from "./model-list.vue?vue&type=script&lang=js&"
export * from "./model-list.vue?vue&type=script&lang=js&"
import style0 from "./model-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports